import { HelperCore, HelpOther } from '@/common/helper';
import { makeAutoObservable, runInAction } from 'mobx';
import { createSlsLogger } from '@public/log/sls';
import Request from '@src/common/request';
import CreateWcpModal from './';
import Loader from '@/common/helper/loader';
import EE from '@/common/event';
import agentPageStore from '@/pages/agent-home/store';
const slsLogger = createSlsLogger('client');

class Store {
  agentImage = '';
  defaultImage = 'https://p0.ssl.qhimg.com/t110b9a930137261518796ffe16.png'
  defaultHoverImage = 'https://p5.ssl.qhimg.com/t110b9a930142fa62fb6fb54b4d.png'
  currentImage = this.defaultImage
  mcpList = [];
  genLoading = false;
  disableGened = false;
  sunmitLoading = false;
  fields = {
    greeting: '',
    icon: '',
  };
  genCount = 0;

  constructor() {
    makeAutoObservable(this);
  }

  get fields() {
    return this.fields;
  }

  get greeting() {
    return this.fields.greeting;
  }

  get icon() {
    return this.fields.icon;
  }

  get server_list() {
    return this.fields.server_list;
  }

  get dataset_id() {
    return this.fields.dataset_id;
  }

  get intro() {
    return this.fields.intro;
  }

  get title() {
    return this.fields.title;
  }

  get saylist_detail() {
    return this.fields.saylist_detail;
  }

  setDisableGened(boolean) {
    runInAction(() => {
      this.disableGened = boolean;
    });
  }

  setDefaultImage = (url) => {
    runInAction(() => {
      this.currentImage = url
    })
  }

  setAgentImage(url) {
    this.agentImage = url;
  }

  loadMCPlist() {
    Request.get('/ai_agent/mcp/list', {
      params: {},
    })
      .then(res => {
        runInAction(() => {
          this.mcpList = res.data.map(item => {
            return {
              ...item,
              value: item.server_id,
              label: item.display_name,
            };
          });
        });
      })
      .catch(e => {});
  }

  getCurrentMcp(id) {
    return this.mcpList.find(item => item.server_id == id);
  }

  createMcp(data) {
    runInAction(() => {
      this.sunmitLoading = true;
    });
    Request.post(
      '/ai_agent/edit',
      {
        ...data,
      },
      { dataIsJson: true }
    )
      .then(res => {
        HelpOther.toast('创建成功');

        runInAction(() => {
          this.sunmitLoading = false;
        });
        CreateWcpModal.close();
        //创建成功之后进入该智能体
        if(res.data?.id){
          agentPageStore.gotoAgentChat(res.data?.id);
        } 
        EE.emit("AIAgentEdit", data);
      })
      .catch(e => {
        runInAction(() => {
          this.sunmitLoading = false;
        });
        Loader.error(e);
      });
  }

  getMcpDetail(id) {
    return Request.get('/ai_agent/detail', {
      params: {
        id,
      },
    }).then(res => {
      const {
        icon,
        greeting,
        server_list,
        dataset_id,
        saylist_detail,
        title,
        intro,
        role_id
      } = res.data;
      runInAction(() => {
        this.agentImage = icon;
        this.fields = {
          greeting,
          server_list,
          dataset_id,
          saylist_detail,
          title,
          intro,
          role_id
        };
      });
      return {
        icon,
        greeting,
        server_list,
        dataset_id,
        saylist_detail,
        title,
        intro,
        role_id
      };
    }).catch((e) => {
      HelpOther.toast(e.message, 'error')
      return null
    })
  }

  isHttpOrHttps(url) {
    return /^https?:\/\//i.test(url);
  }
  genFormContent(title) {
    runInAction(() => {
      this.genLoading = true;
    });
    Request.get('ai_agent/gen_info', {
      params: {
        title,
        timeout: 60000,
      },
    })
      .then(res => {
        runInAction(() => {
          if (res.data) {
            this.fields = {
              ...res.data,
            };
          }
          
          this.genCount = ++this.genCount;
          if (this.isHttpOrHttps(res.data?.icon)) {
            this.agentImage = res.data?.icon;
          } else {
            this.agentImage = this.defaultImage;
          }

          this.genLoading = false;
        });
      })
      .catch(e => {
        HelpOther.toast(e.message, 'error');
        this.genLoading = false;
      });
  }

  resetForm() {
    runInAction(() => {
      this.fields = {};
      this.agentImage = '';
      this.genLoading = false;
      this.disableGened = false;
      this.genCount = 0;
    });
  }
}

const createWcpStore = new Store();
export default createWcpStore;
